import React from "react";
import { OnboardingSave } from "../../interfaces/onboarding";
import OnboardingStep1 from "./steps/step1";
import OnboardingStep2 from "./steps/step2";
import "./style.scss";

interface OnboardingComponentProps {
    step: number;
    setStep: (val: number) => void;
    onSave: (bodyRequest: OnboardingSave) => void;
}

const OnboardingComponent = (props: OnboardingComponentProps) => {
    switch (props.step) {
        case 2:
            return (
                <OnboardingStep2
                    onSave={props.onSave}
                    setStep={props.setStep}
                />
            );
        default:
            return <OnboardingStep1 setStep={props.setStep} />;
    }
};

export default OnboardingComponent;
